//#region Util Imports

import * as _ from 'underscore'

//#endregion

import { ColumnModel } from '../../../../../../../api/api.models'

import { OpRole, OpOperator } from '../../../../../../../../models/core'
import { Activity, Enums } from '../../../../../../../../models/common'

import { OperatorSecurityService } from '../../../../../../../../services/operator'
import { UserSessionService } from '../../../../../../../../services/user-session'

import { IMRBaseControlController } from '../../../../../../../common/base'
import { GridTypes } from '../../../../../../../common/grid'
import { IMREditGridOptions, IIMREditGrid, IMREditGridInitializedArgs, IMREditGridSubmitArgs } from '../../../../../../../common/edit-grid'

import { IOperatorDetailsSecurityRoles, OperatorDetailsSecurityRolesOptions } from './operator-details.security.roles.interfaces'

export class OperatorDetailsSecurityRolesController
    extends
    IMRBaseControlController<IOperatorDetailsSecurityRoles, OperatorDetailsSecurityRolesOptions>
    implements
    IOperatorDetailsSecurityRoles {

    //#region Consts

    private get OPERATOR_ROLES_GRID_NAME() { return 'roles' }
    private get OPERATOR_SELECT_ROLES_GRID_NAME() { return 'usersSecurityRolesGrid' }

    //#endregion


    //#region Members

    public isLoading: boolean
    private operatorToEdit: OpOperator

    //#endregion


    //#region Ctor

    public constructor(
        private operatorSecurityService: OperatorSecurityService,
        private userSessionService: UserSessionService
    ) {
        super()
    }

    //#endregion


    //#region Component

    protected initialize(options: OperatorDetailsSecurityRolesOptions): JQueryPromise<void> {
        this.isLoading = true
        this.setOperator(options.operator)

        return $
            .when(
                this.initializeRolesEditGrid()
            )
            .then(() => {
                this.isLoading = false
            })
    }

    //#endregion


    //#region IOperatorDetailsSecurityRoles Implementation

    public hasChanges(): boolean {
        return this.rolesEditGrid != null ? this.rolesEditGrid.hasChanges() : false;
    }

    public setOperator(operator: OpOperator): void {
        this.operatorToEdit = operator.clone(true, true, true, true)
    }

    public reset(): void {
        if (this.rolesEditGrid != null) {
            this.rolesEditGrid.reset()
        }
    }

    //#endregion


    //#region Grid Edit

    public rolesEditGridOptions: IMREditGridOptions<OpRole, OpRole>
    private rolesEditGrid: IIMREditGrid<OpRole, OpRole>

    private initializeRolesEditGrid(): void {
        const canEditRoles: boolean = this.userSessionService.getLoggedOperator().hasPermission(Activity.ALLOWED_OPERATOR_TO_EDIT_ACTIVITIES)

        this.operatorSecurityService
            .getRoleColumns()
            .then((columns: ColumnModel[]) => {
                this.rolesEditGridOptions = {
                    allowEditing: canEditRoles,

                    sourceGridOptions: {
                        addCustomFilters: true,
                        columnsDictionary: columns,
                        idReferenceType: Enums.ReferenceType.IdRole,
                        name: this.OPERATOR_SELECT_ROLES_GRID_NAME,
                        type: GridTypes.PAGINATED_SMALL,

                        buttonsOptions: {
                            enabled: true,
                            isRefreshButonHidden: true
                        },

                        getDataSource: () => {
                            return this.operatorSecurityService.getAvailableRoles()
                        },
                    },

                    targetGridOptions: {
                        addCustomFilters: true,
                        columnsDictionary: columns,
                        ignoreKey: true,
                        idReferenceType: Enums.ReferenceType.IdRole,
                        name: this.OPERATOR_ROLES_GRID_NAME,
                        type: GridTypes.PAGINATED_SMALL,

                        allowColumnReordering: !this.userSessionService
                            .getLoggedOperator()
                            .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.OperatorSecurityRole),

                        buttonsOptions: {
                            enabled: true,
                            isRefreshButonHidden: true
                        },

                        getDataSource: () => {
                            return this.operatorToEdit.roles
                        },
                    },

                    onInitialized: (e: IMREditGridInitializedArgs<OpRole, OpRole>) => {
                        this.rolesEditGrid = e.component
                    },

                    onDisposed: () => {
                        this.rolesEditGrid = null
                    },

                    onSubmit: (e: IMREditGridSubmitArgs<OpRole, OpRole>) => {
                        super.callEvent(this.options.onSubmit, {
                            addedRoles: e.addedObjects,
                            deletedRoles: e.deletedObjects
                        })
                    }
                }
            })
    }

    //#endregion
}
